import React from "react";
import { ScrollView } from "react-native";
import tw from "twrnc";

const AppContent = ({
  children,
  isTopAligned = false,
  maxWidth = 1294,
  padding = 20,
  style,
  contentContainerStyle,
  ...props
}) => {
  return (
    <ScrollView
      style={[tw`flex-1`, style]}
      contentContainerStyle={[
        tw`flex-grow self-center w-full`,
        {
          justifyContent: isTopAligned ? "flex-start" : "center",
          maxWidth,
          padding,
          minHeight: isTopAligned ? "auto" : "100%",
        },
        contentContainerStyle,
      ]}
      showsVerticalScrollIndicator={false}
      bounces={false}
      {...props}
    >
      {children}
    </ScrollView>
  );
};

export default AppContent;
